function DefaultLayout({ children }) {
  return <div>{children}</div>;
}

export default DefaultLayout;
